namespace $ {

	const $shm_hitalama_domain_link_default = 'Cyi9zFBh_XpZfv2tb'
	const $shm_hitalama_domain_link_legacy = 'DUzQmtUH_KQ0INJej'
	const $shm_hitalama_team_catalog_link_default = '8awn4aA9_XGV94rfv'
	
	export class $shm_hitalama_domain extends $giper_baza_entity.with({

		/** @deprecated Use profile home/key auth instead. */
		Profiles: $giper_baza_atom_link.to( ()=> $shm_hitalama_profile_dict ),

		Projects: $giper_baza_list_link.to( ()=> $shm_hitalama_project ),
		Projects_catalog: $giper_baza_atom_link.to( ()=> $giper_baza_list_link.to( ()=> $shm_hitalama_project ) ),
		Project_entities: $shm_hitalama_project_dict,
		Project_entities_catalog: $giper_baza_atom_link.to( ()=> $shm_hitalama_project_dict ),
		Doc_maps: $giper_baza_list_link.to( ()=> $shm_hitalama_map ),
		Task_maps: $giper_baza_list_link.to( ()=> $shm_hitalama_map ),
		Projects_map: $giper_baza_atom_link.to( ()=> $shm_hitalama_map ),
		Team_catalog: $giper_baza_atom_link.to( ()=> $shm_hitalama_team_catalog ),
		Map_access_catalog: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_access_catalog ),
		Benchmark_catalog: $giper_baza_atom_link.to( ()=> $shm_hitalama_benchmarks_archive_catalog ),
		Components_catalog: $giper_baza_atom_link.to( ()=> $shm_hitalama_components_catalog ),
		Skills_catalog: $giper_baza_atom_link.to( ()=> $shm_hitalama_skills_catalog ),
		Guide_catalog: $giper_baza_atom_link.to( ()=> $shm_hitalama_guide_catalog ),
	}){

		@ $mol_mem
		static domain_link( next?: string ){
			$mol_wire_solid()
			if( next !== undefined ) return this.$.$mol_state_local.value( this+'.domain_link', next ) || $shm_hitalama_domain_link_default

			const config = this.$.$mol_error_fence(
				()=> this.$.$shm_hitalama_settings.tauri_config(),
				()=> null,
				()=> null,
			)
			if( config?.selfhosted_tauri && config.domain_link ) {
				return this.$.$mol_state_local.value( this+'.domain_link', config.domain_link ) || config.domain_link
			}

			const stored = this.$.$mol_state_local.value< string >( this+'.domain_link' )
			return this.$.$shm_hitalama_domain_config.resolve( stored, $shm_hitalama_domain_link_default, [
				$shm_hitalama_domain_link_legacy,
				'QEhDeqwP_DiG9B13t',
			] )
		}

		@ $mol_mem
		static instance() {
			$mol_wire_solid()
			const ref = new $giper_baza_link( this.domain_link() )
			const domain = this.$.$giper_baza_glob.Pawn( ref, $shm_hitalama_domain )
			return domain
		}
		
		/** @deprecated Use profile home/key auth instead. */
		@ $mol_mem
		profiles() {
			$mol_wire_solid()
			return this.Profiles()?.remote()!
		}

		/** @deprecated Use profile home/key auth instead. */
		@ $mol_action
		profiles_ensure() {
			const profiles = this.profiles()
			if( profiles && ( profiles.can_change() || !this.can_change() ) ) return profiles

			const next = this.can_change()
				? this.land().area_make().Data( this.$.$shm_hitalama_profile_dict )
				: this.$.$giper_baza_glob.land_grab( [[ null, this.$.$giper_baza_rank_make( 'post', 'just' ) ]] ).Data( this.$.$shm_hitalama_profile_dict )
			this.Profiles(null)?.remote( next )
			return next
		}

		@ $mol_mem
		projects() {
			$mol_wire_solid()
			return this.Projects_catalog()?.remote() ?? this.Projects()
		}

		project_entities( ensure = false ) {
			const linked = this.Project_entities_catalog()?.remote()
			if( linked ) return linked
			// Old domains keep their inline index. A reader must not create
			// fields in a protected manifest just to open a project.
			return this.Project_entities( ensure && this.can_change() ? null : undefined )
		}

		project_entity( id: string, ensure = false ) {
			const entities = this.project_entities( ensure )
			const link = entities?.key( id, ensure ? null : undefined )
			const project = ensure ? link?.ensure( entities!.land() ) ?? null : link?.remote() ?? null
			if( ensure && project ) project.Project_id( null )!.val( id )
			return project
		}

		private readonly project_catalog_pending = new Promise< never >( ()=> {} )

		@ $mol_mem
		project_entities_ready() {
			const entities = this.project_entities()
			if( !entities ) return null
			const land = entities.land().sync()
			land.loading()
			// loading() covers the local disk, not the master. A cold catalog's
			// fallback read rank is not a denial. Subscribe to its reactive Gift
			// map and suspend until its actual permissions arrive. Wire wakes this
			// channel on invalidation; no polling or manual render is necessary.
			if( !entities.can_change() && land._gift.size === 0 ) {
				$mol_fail_hidden( this.project_catalog_pending )
			}
			return entities
		}

		@ $mol_mem_key
		project_draft( id: string, next?: string ) {
			// Cold linked catalogs may initially report no write permissions. Wait
			// for their actual rights instead of silently dropping the first edit.
			if( next !== undefined ) this.project_entities_ready()
			const project = this.project_entity( id, next !== undefined )
			if( !project ) {
				if( next !== undefined ) $mol_fail( new Error( 'Не удалось сохранить черновик: индекс проектов недоступен. Повторите после загрузки.' ) )
				return ''
			}
			if( next !== undefined ) {
				project.land().sync().loading()
				if( !project.can_change() ) $mol_fail( new Error( 'Не удалось сохранить черновик: нет прав на редактирование проекта.' ) )
			}
			return project.Draft_note( next === undefined ? undefined : null )?.val( next ) ?? ''
		}

		static team_catalog_link_value = $shm_hitalama_team_catalog_link_default

		static team_catalog_link( next?: string ) {
			if( next !== undefined ) this.team_catalog_link_value = next || $shm_hitalama_team_catalog_link_default
			return this.team_catalog_link_value
		}

		static team_catalog() {
			return this.$.$giper_baza_glob.Pawn(
				new this.$.$giper_baza_link( this.team_catalog_link() ),
				this.$.$shm_hitalama_team_catalog,
			)
		}

		team_catalog_current() {
			const linked = this.Team_catalog()?.remote()
			if( linked ) return linked

			const legacy = this.team_catalog_legacy()
			return legacy?.Teams() ? legacy : null
		}

		team_catalog_legacy() {
			const id = this.link().str
			if( id !== $shm_hitalama_domain_link_default && id !== $shm_hitalama_domain_link_legacy ) return null
			return this.$.$shm_hitalama_domain.team_catalog()
		}

		@ $mol_mem
		teams() {
			return this.team_catalog_current()?.Teams() ?? null
		}

		@ $mol_action
		teams_public_ensure() {
			let catalog = this.Team_catalog()?.remote() ?? null
			if( !catalog ) {
				const legacy = this.team_catalog_legacy()
				if( legacy?.Teams() ) {
					catalog = legacy
					if( this.can_change() ) this.Team_catalog( null )?.remote( legacy )
				} else {
					if( !this.can_change() ) return null
					catalog = this.Team_catalog( null )?.ensure([
						[ null, this.$.$giper_baza_rank_make( 'post', 'just' ) ],
					]) ?? null
				}
			}

			return catalog?.Teams() ?? catalog?.Teams( null ) ?? null
		}

		team_records() {
			const unique = new Map< string, $shm_hitalama_team >()
			for( const team of this.teams()?.remote_list() ?? [] ) {
				const id = team.link().toString()
				if( id && !unique.has( id ) ) unique.set( id, team )
			}
			return [ ...unique.values() ]
		}

		teams_for_user( user_id: string ) {
			return this.team_records().filter( team => Boolean( team.member_by_user( user_id ) ) )
		}

		@ $mol_action
		team_create( name: string, projects_api_url: string, projects_api_token: string, creator_id: string, creator_name: string ) {
			const teams = this.teams_public_ensure()
			if( !teams ) return null

			const team = this.$.$giper_baza_glob
				.land_grab( [[ null, this.$.$giper_baza_rank_read ]] )
				.Data( this.$.$shm_hitalama_team )
			const secret = this.$.$giper_baza_glob
				.land_grab( [[ null, this.$.$giper_baza_rank_deny ]] )
				.Data( this.$.$shm_hitalama_team_secret )
			team.Name( null )!.val( name.trim() )
			team.Creator_id( null )!.val( creator_id )
			team.Projects_api_url( null )!.val( projects_api_url.trim() )
			team.Admins( null )!.items([ creator_id ])
			team.Secret( null )!.remote( secret )
			secret.Projects_api_token( null )!.val( projects_api_token.trim() )
			team.member_add( creator_id, creator_name || creator_id )
			team.maps_list( null )
			teams.remote_add( team )
			return team
		}
		
		/** @deprecated Use profile home/key auth instead. */
		@ $mol_mem
		static pull_pass_keys() {
			const profiles = this.instance().profiles()!
			profiles?.keys().forEach( k => {
				try {
					profiles.key(k)?.remote()?.Pass_key()?.val() 
				} catch (error) {
					console.log( error )
				}
			} )
		}

		/** @deprecated Use profile home/key auth instead. */
		@ $mol_mem
		static pull_pass_keys_periodic() {
			return new $mol_wire_atom( '', ()=> {
				$mol_state_time.now( 1000 )
				this.pull_pass_keys()
			} ).plan()
		}
		
	}
}
